import Clarity from "@microsoft/clarity";

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

/**
 * @microsoft/clarity's exported functions call window.clarity(...) directly.
 * If Clarity.init() was never called (e.g. REACT_APP_CLARITY_ID is unset,
 * as in local dev), window.clarity doesn't exist and those calls throw
 * "window.clarity is not a function". Every call site must go through
 * these guarded wrappers instead of importing @microsoft/clarity directly.
 */
const isReady = () =>
  typeof window !== "undefined" && typeof window.clarity === "function";

export const clarityEvent: typeof Clarity.event = (eventName) => {
  if (isReady()) Clarity.event(eventName);
};

export const claritySetTag: typeof Clarity.setTag = (key, value) => {
  if (isReady()) Clarity.setTag(key, value);
};

export const clarityConsentV2: typeof Clarity.consentV2 = (consentOptions) => {
  if (isReady()) Clarity.consentV2(consentOptions);
};
